import { Splide } from '@splidejs/splide';

export default () => {
	class ProductRecommendations extends window.BAO.CustomElement() {
		constructor() {
			super();
		}

		connectedCallback() {
			this.render();
		}

		render() {
			// Prevent multiple simultaneous renders
			if (this.isRendering) {
				console.log("⏳ Render already in progress, skipping...");
				return;
			}
			
			this.isRendering = true;

			// Target only the products container
			const productsContainer = this.querySelector('[data-recommendations-target]');
			if (!productsContainer) {
				console.error("Products container not found");
				this.isRendering = false;
				return;
			}

			fetch(this.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;

					const recommendations = html.querySelector('product-recommendations');
					const newProductsContainer = recommendations?.querySelector('[data-recommendations-target]');
					const hasItems = newProductsContainer && newProductsContainer.innerHTML.trim().length;

					if (hasItems) {
						// Create new products container for cross-fade
						const newProductsElement = document.createElement('div');
						newProductsElement.className = productsContainer.className;
						newProductsElement.setAttribute('data-recommendations-target', '');
						newProductsElement.innerHTML = newProductsContainer.innerHTML;
						
						// Set up container for cross-fade positioning
						const container = productsContainer.parentNode;
						const currentHeight = productsContainer.offsetHeight;
						
						// Measure new content height by temporarily adding it off-screen
						newProductsElement.style.cssText = `
							position: absolute;
							top: -9999px;
							left: 0;
							width: 100%;
							opacity: 0;
							visibility: hidden;
						`;
						container.appendChild(newProductsElement);
						const newHeight = newProductsElement.offsetHeight;
						
						// Set container to accommodate both old and new content
						const maxHeight = Math.max(currentHeight, newHeight);
						container.style.position = 'relative';
						container.style.minHeight = `${maxHeight}px`;
						container.style.transition = 'min-height 0.4s ease-in-out';
						
						// Now position new element properly for cross-fade
						newProductsElement.style.cssText = `
							position: absolute;
							top: 0;
							left: 0;
							width: 100%;
							opacity: 0;
							transition: opacity 0.4s ease-in-out;
							z-index: 2;
						`;
						
						productsContainer.style.transition = 'opacity 0.6s ease-in-out';
						productsContainer.style.zIndex = '1';
						
						newProductsElement.offsetHeight;
						
						newProductsElement.style.opacity = '1';
						
						setTimeout(() => {
							productsContainer.style.opacity = '0';
						}, 100);
						
						// Clean up after transition
						setTimeout(() => {
							productsContainer.remove();
							
							// Normalize new container positioning
							newProductsElement.style.position = 'static';
							newProductsElement.style.opacity = '1';
							newProductsElement.style.transition = '';
							newProductsElement.style.zIndex = '';
							
							// Set final height to new content
							container.style.minHeight = `${newHeight}px`;
							
							// Final cleanup
							setTimeout(() => {
								container.style.minHeight = '';
								container.style.position = '';
								container.style.transition = '';
								this.isRendering = false;
							}, 400);
						}, 700);
					} else {
						this.isRendering = false;
					}
				})
				.catch((e) => {
					console.error("Error fetching recommendations:", e);
					this.isRendering = false;
				});
		}

		get url() {
			return this.dataset.url;
		}
	}

	class ProductRecommendationsCarousel extends window.BAO.CustomElement() {
		constructor() {
			super();
			this.initCarousel = this.initCarousel.bind(this);
		}

		connectedCallback() {
			this.initCarousel();
		}

		initCarousel() {
			const slider = new Splide(this.els.slides.element, {
				focus: 'center',
				direction: 'ltr',
				speed: 700,
				arrows: false,
				pagination: false,
				height: '100%',
				perPage: 2.2,
				wheelSleep: 750,
				drag: true,
				mediaQuery: 'max',
				breakpoints: {
					1023: {
						direction: 'ltr',
						perPage: 1.2,
						autoHeight: false,
						wheel: false,
					},
				},
			}).mount();
		}
	}

	class RecommendationsCard extends window.BAO.CustomElement() {
		constructor() {
			super();

			this.onChange = this.onChange.bind(this);
		}

		connectedCallback() {
			super.connectedCallback();
		}

		setupListeners() {
			super.setupListeners();

			if (this.els.select && this.els.select.exists) {
				this.listeners.add(this.els.select.element, 'change', this.onChange);
			}
		}

		setVariant(id) {
			this.els.add.element.setAttribute('data-id', id);
		}

		onChange() {
			this.setVariant(this.els.select.element.value);
		}
	}

	if (!customElements.get('product-recommendations')) {
		customElements.define('product-recommendations', ProductRecommendations);
	}

	if (!customElements.get('recommendations-card')) {
		customElements.define('recommendations-card', RecommendationsCard);
	}

	if (!customElements.get('product-recommendations-carousel')) {
		customElements.define(
			'product-recommendations-carousel',
			ProductRecommendationsCarousel,
		);
	}
};
